import { useMutation, useQuery } from "react-query";
import { toast } from "react-toastify";
import { NewsServices } from "../api";

const onDefaultError = (error) => {
  toast.error(error.message);
};
/**
 * Hook for Admin Organisation States Master section
 */
const useListNews = ([page_no], onSuccess, onError = onDefaultError) => {
  return useQuery(["news-list", page_no], NewsServices.newsList, {
    onSuccess,
    keepPreviousData: true,
    onError,
  });
};
const useAddNews = (onSuccess, onError = onDefaultError) => {
  return useMutation(NewsServices.addNews, {
    onSuccess,
    onError,
  });
};
const useUpdateNews = (onSuccess, onError = onDefaultError) => {
  return useMutation(NewsServices.updateNews, {
    onSuccess,
    onError,
  });
};
const useViewNews = (id, onSuccess, onError = onDefaultError) => {
  return useQuery("news-view", () => NewsServices.viewNews({ id }), {
    onSuccess,
    onError,
  });
};
const useNewsDelete = (onSuccess, onError = onDefaultError) => {
  return useMutation(NewsServices.deleteNews, {
    onSuccess,
    onError,
  });
};
export { useListNews, useAddNews, useUpdateNews, useViewNews, useNewsDelete };
